import { PhoneIcon, MapPinIcon } from '@heroicons/react/24/outline';

const CardProfessional = ({ professional, onClick }) => {
  return (
    <div
      className={`bg-white p-4 rounded-xl shadow hover:bg-gray-50 cursor-pointer transition ${
        !professional.is_active ? 'opacity-60' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-center gap-2">
        <h3 className="text-md font-semibold">{professional.name}</h3>
        {!professional.is_active && (
          <span className="px-2 py-0.5 bg-gray-200 text-gray-600 text-[10px] rounded-full">Inactive</span>
        )}
      </div>

      {(professional.location || professional.phone) && (
        <div className="mt-1.5 space-y-1">
          {professional.location && (
            <p className="flex items-center gap-1.5 text-sm text-gray-600">
              <MapPinIcon className="h-4 w-4 text-gray-400 flex-shrink-0" />
              {professional.location}
            </p>
          )}
          {professional.phone && (
            <p className="flex items-center gap-1.5 text-sm text-gray-600">
              <PhoneIcon className="h-4 w-4 text-gray-400 flex-shrink-0" />
              {professional.phone}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CardProfessional;
